import { ComponentAlign, ComponentPadding, Container, DensitySpacing, Orientation, Typography, TypographyVariant } from '@tcc/fds';
import { RegionReportItemsValue } from './RegionReportItemsValue';
import { isoToDateString } from '../../../../utils/date';
import { ApplicationStats } from '../../../../types';

export type ApplicationStatsLabelProps = {
  dataTestId: string;
  item: ApplicationStats;
  locale: string;
  index: number;
  cropCode: string;
  cropNominalWeight?: number;
};

export const ApplicationStatsLabel = ({
  dataTestId,
  item,
  locale,
  index,
  cropCode,
  cropNominalWeight,
}: ApplicationStatsLabelProps) => {
  const { averageYield, area, dateApplied = '' } = item;
  const applicationDate = isoToDateString(dateApplied.slice(0, 10), locale);

  return (
    <Container
      testId={`dmb-region-report-${dataTestId}-stats-label`}
      key={`dmb-region-report-item-${item.label}`}
      width='100%'
      orientation={Orientation.Horizontal}
      padding={DensitySpacing.Related}
      gap={DensitySpacing.None}>
        <Container
          orientation={Orientation.Vertical}
          width='50%'
          padding={ComponentPadding.None}
          gap={DensitySpacing.Together}
          align={ComponentAlign.Start}
        >
          <Typography variant={TypographyVariant.Label} testId={`dmb-region-report-${dataTestId}-label`}>
            {item.label}
          </Typography>
          <Typography variant={TypographyVariant.UltraNarrow} testId={`dmb-region-report-${dataTestId}-date`}>
              {applicationDate}
          </Typography>
        </Container>
        
      <RegionReportItemsValue 
        area={area} 
        averageYield={averageYield} 
        dataTestId={dataTestId} 
        index={index}
        cropCode={cropCode}
        cropNominalWeight={cropNominalWeight}
        isArdData={false}
      />
    </Container>
  );
};